import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled } from 'sensortower-components/src/utils/styled';
import Link, { LinkProps } from 'sensortower-components/src/base-components/Link';
import Media from 'sensortower-components/src/base-components/Media';
import { MediaProps } from 'sensortower-components/src/base-components/Media/Media.types';
import Text, { RichText } from 'sensortower-components/src/base-components/Text';
import ErrorBoundary from 'sensortower-components/src/base-components/ErrorBoundary';
import { sidekick } from '../../utils/sidekick';

export interface CommonResourceProps {
  __typename?: string;
  id: string;
  key: string;
  shortTextValue?: string;
  longTextValue?: RichText;
  richTextValue?: RichText;
  linkValue?: LinkProps;
  mediaValue?: MediaProps | MediaProps[];
  sidekickLookup: any;
}

export const CommonResource = ({
  shortTextValue,
  longTextValue,
  richTextValue,
  linkValue,
  mediaValue,
  sidekickLookup,
}: CommonResourceProps) => {
  return (
    <ErrorBoundary>
      <Root {...sidekick(sidekickLookup)} data-testid="CommonResource">
        {mediaValue ? (
          <Media
            {...(Array.isArray(mediaValue) ? mediaValue[0] : mediaValue)}
            {...sidekick(sidekickLookup?.mediaValue)}
            testId="CommonResource-mediaValue"
            sx={{
              paddingBottom: '1rem',
            }}
          />
        ) : null}
        {shortTextValue ? (
          <Typography
            {...sidekick(sidekickLookup?.shortTextValue)}
            variant="h4"
            component="h4"
            data-testid="CommonResource-shortTextValue"
            sx={{
              paddingBottom: '1rem',
            }}
          >
            {shortTextValue}
          </Typography>
        ) : null}
        {longTextValue ? (
          <Text
            sidekickLookup={sidekickLookup?.longTextValue}
            body={longTextValue}
            data-testid="CommonResource-longTextValue"
          />
        ) : null}
        {richTextValue ? (
          <Text
            sidekickLookup={sidekickLookup?.richTextValue}
            body={richTextValue}
            data-testid="CommonResource-richTextValue"
          />
        ) : null}
        {linkValue ? (
          <Link
            {...(linkValue as any)}
            {...sidekick(sidekickLookup?.linkValue)}
            data-testid="CommonResource-linkValue"
          />
        ) : null}
      </Root>
    </ErrorBoundary>
  );
};

export default CommonResource;

const Root = styled(Box, {
  name: 'CommonResource',
  slot: 'Root',
  overridesResolver: (_, styles) => ({
    ...(styles.root as any),
  }),
})<{ variant?: string }>(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  '& .MuiTypography-root': {
    paddingBottom: theme.spacing(2),
  },
}));
